export default {
  home: {
    meta: {
      title: "AllChinaBuy Spreadsheet 2026 : Trouvailles, guides & ressources",
      description:
        "Explorez le dernier AllChinaBuy spreadsheet, les trouvailles, guides d'achat, conseils d'expédition, informations QC et ressources liées dans un hub organisé.",
      keywords:
        "AllChinaBuy spreadsheet, AllChinaBuy trouvailles, AllChinaBuy guide, AllChinaBuy avis",
    },
    hero: {
      badge: "Mis à jour pour 2026 · Multilingue · Pensé pour les acheteurs",
      title: "AllChinaBuy Spreadsheet",
      titleAccent: "— Découvrez de meilleures trouvailles",
      subtitle:
        "À la recherche du dernier AllChinaBuy spreadsheet ? Explorez des trouvailles organisées, des guides d'achat, des informations QC, des conseils d'expédition et des ressources liées — le tout dans un hub simple et consultable.",
      ctaPrimary: "Explorer le AllChinaBuy Spreadsheet",
      ctaSecondary: "Acheter maintenant",
      trust: "Ressource indépendante · Mise à jour régulière · Multilingue",
      mockup: {
        label: "Aperçu du spreadsheet",
        header: "Catégorie",
        headerProduct: "Produit",
        headerResource: "Ressource",
        headerQc: "QC",
        headerUpdated: "MàJ",
        row1: "Chaussures",
        row1Product: "Baskets",
        row1Qc: "Oui",
        row2: "Hoodies",
        row2Product: "Sweat",
        row2Qc: "Oui",
        row3: "Sacs",
        row3Product: "Tote",
        row3Qc: "Oui",
        row4: "Accessoires",
        row4Product: "Montre",
        row4Qc: "Avis",
      },
    },
    categories: {
      title: "Parcourir par catégorie",
      subtitle:
        "Choisissez une catégorie dans le menu déroulant ou les cartes ci-dessous pour accéder directement à la sélection correspondante sur le site principal.",
      dropdownLabel: "Choisir une catégorie",
      dropdownPlaceholder: "Sélectionnez une catégorie pour continuer",
      dropdownCta: "Aller à la catégorie",
      gridTitle: "Catégories de produits populaires",
      gridSubtitle: "Touchez une catégorie pour explorer les trouvailles sur le site principal.",
      allExternal: "Toutes les catégories s'ouvrent dans un nouvel onglet.",
    },
    about: {
      title: "Tout ce qu'il faut pour explorer AllChinaBuy",
      subtitle:
        "Trouvez les informations nécessaires avant de parcourir, comparer ou acheter — organisées pour aller plus vite.",
      p1: "Un AllChinaBuy spreadsheet est une façon simple et organisée de suivre vos trouvailles, notes de vendeur, résultats QC et détails d'expédition au même endroit. Au lieu de faire défiler sans fin les résultats, les acheteurs utilisent un spreadsheet pour rassembler des liens, comparer les options et planifier leur prochaine commande avec une vue claire.",
      p2: "Ce hub réunit les ressources les plus utiles autour du AllChinaBuy spreadsheet — des raccourcis par catégorie aux guides d'achat, en passant par l'expédition et le QC — pour passer moins de temps à chercher et plus de temps à trouver ce que vous voulez vraiment.",
      points: {
        organized: {
          title: "Trouvailles organisées",
          desc: "Rassemblez produits et liens dans une vue claire et consultable.",
        },
        compare: {
          title: "Comparaison facile",
          desc: "Comparez les articles côte à côte avant d'acheter.",
        },
        updated: {
          title: "Toujours à jour",
          desc: "Suivez des guides et ressources régulièrement actualisés.",
        },
      },
    },
    guides: {
      title: "Explorer le centre de ressources",
      subtitle: "Des guides pour acheter plus intelligemment avec AllChinaBuy.",
      cards: {
        spreadsheet: {
          title: "AllChinaBuy Spreadsheet",
          desc: "Explorez les ressources organisées et les catégories de produits.",
        },
        finds: {
          title: "Trouvailles populaires",
          desc: "Découvrez les catégories populaires et les ressources utiles.",
        },
        shipping: {
          title: "Guide d'expédition",
          desc: "Comprenez les méthodes, coûts et points clés de l'expédition.",
        },
        qc: {
          title: "Guide QC",
          desc: "Apprenez à vérifier la qualité avant d'acheter.",
        },
        review: {
          title: "Avis AllChinaBuy",
          desc: "Fonctionnalités, avantages, limites et points à connaître.",
        },
        safety: {
          title: "Centre de sécurité",
          desc: "Vérification des vendeurs, paiements, risques et expédition.",
        },
      },
      cta: "Explorer le centre de ressources",
    },
    article: {
      title: "Derniers guides",
      subtitle: "Des articles frais et originaux pour acheter plus intelligemment.",
      cardTitle: "AllChinaBuy Spreadsheet : le guide complet",
      cardDesc:
        "Découvrez ce qu'est un AllChinaBuy spreadsheet, comment l'utiliser, quelles catégories explorer et les astuces pour trouver de meilleurs produits plus vite.",
      tag: "Guide complet",
      readMore: "Lire le guide complet",
      updated: "Dernière mise à jour",
    },
    faq: {
      title: "Questions fréquentes",
      subtitle: "Des réponses rapides aux questions les plus courantes sur le AllChinaBuy spreadsheet.",
      q1: "Qu'est-ce qu'un AllChinaBuy spreadsheet ?",
      a1: "C'est une ressource organisée qui liste les trouvailles, catégories, notes de vendeur et détails QC pour parcourir et comparer en un seul endroit.",
      q2: "Comment utiliser un AllChinaBuy spreadsheet ?",
      a2: "Choisissez une catégorie, parcourez les trouvailles liées, puis comparez avant d'ouvrir le site principal pour finaliser votre achat.",
      q3: "AllChinaBuy est-il légitime ?",
      a3: "AllChinaBuy est une plateforme d'achat, mais vous devez toujours évaluer vous-même les produits, vendeurs, paiements et options d'expédition avant de décider.",
      q4: "AllChinaBuy est-il sûr ?",
      a4: "La sécurité dépend de votre usage. Examinez les infos vendeur, photos QC et options de paiement avant de commander.",
      q5: "Combien coûte l'expédition AllChinaBuy ?",
      a5: "Les coûts varient selon la destination, le poids et la méthode. Vérifiez les tarifs actuels sur le site principal pour une estimation précise.",
      q6: "AllChinaBuy a-t-il des coupons ?",
      a6: "Les promotions changent avec le temps. Consultez le site principal pour voir les offres actuelles.",
      q7: "Qu'est-ce que l'entrepôt AllChinaBuy ?",
      a7: "C'est là que les articles sont reçus, stockés, photographiés pour le QC et préparés pour l'expédition internationale.",
      q8: "Comment fonctionne le QC AllChinaBuy ?",
      a8: "Le QC vous permet de demander des photos d'inspection avant l'expédition pour confirmer la qualité et détecter les problèmes tôt.",
    },
    finalCta: {
      title: "Prêt à explorer les ressources AllChinaBuy ?",
      subtitle:
        "Commencez par le AllChinaBuy spreadsheet et découvrez les guides, trouvailles et ressources qui comptent le plus.",
      primary: "Explorer le AllChinaBuy Spreadsheet",
      secondary: "Visiter le site principal",
    },
  },
};